const cognitoConfig = {
  Auth: {
    region: process.env.AUTH_USER_POOL_REGION,
    userPoolId: process.env.AUTH_USER_POOL,
    userPoolWebClientId: process.env.AUTH_APP_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    oauth: {
      domain: 'flytta-crm.auth.ap-south-1.amazoncognito.com',
      scope: ['profile', 'email', 'phone', 'openid'],
      redirectSignIn: 'http://localhost:8080/signin',
      redirectSignOut: 'http://localhost:8080/signout',
      responseType: 'token',
    },
  },
};

export default cognitoConfig;
